import '../app/auth';
import { initTelemetry } from './telemetry';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PortalPage } from '@seller-hermes/pages/portal';
import { PortalUsersPage } from '@seller-hermes/pages/portal';
import { LoginPage } from '@seller-hermes/pages/login.page';
import { LogoutPage } from '@seller-hermes/pages/logout.page';
import { RequireAuth } from './require-auth';

const queryClient = new QueryClient();

initTelemetry();

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RequireAuth><PortalPage /></RequireAuth>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/users" element={<RequireAuth><PortalUsersPage /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </QueryClientProvider>
);
